
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import DataSet from "@antv/data-set";
import { userAnalysisService } from "@/api/payments/user-analysis";
import { UserPaymentDto, UserActiveDto } from "@/api/service-proxies";

const scale = [
  {
    dataKey: "percent",
    min: 0,
    formatter: ".0%",
  },
];

@Component({})
export default class StaticsScale extends Vue {
  @Prop({ type: String, default: "all" }) sourceType!: string;
  platformType: number | undefined = undefined;

  userPayment: UserPaymentDto = new UserPaymentDto();

  userActive: UserActiveDto = new UserActiveDto();

  created() {
    this.fetchData();
  }

  scale = scale;
  height = 280;
  pieStyle = {
    stroke: "#fff",
    lineWidth: 1,
  };
  labelConfig = [
    "percent",
    {
      formatter: (val, item) => {
        return item.point.item + ": " + val;
      },
    },
  ];

  @Watch("sourceType")
  watchSourceType(newVal: string) {
    if (newVal == "all") this.platformType = undefined;
    else if ((newVal = "wechat")) this.platformType = 2;
    else if (newVal == "alipay") this.platformType = 3;

    this.fetchData();
  }

  async fetchData() {
    this.userPayment = await userAnalysisService.getUserPayment(
      this.platformType
    );
    this.userActive = await userAnalysisService.getUserActive(
      this.platformType
    );
  }

  get userActiveData() {
    const sourceData = [
      {
        item: "1个星期",
        count: this.userActive.weekCount,
      },
      {
        item: "1个月",
        count: this.userActive.aMonthCount,
      },
      {
        item: "3个月",
        count: this.userActive.month3Count,
      },
    ];
    const dv = new DataSet.View().source(sourceData);
    dv.transform({
      type: "percent",
      field: "count",
      dimension: "item",
      as: "percent",
    });
    return dv.rows;
  }

  get userModuleData() {
    const sourceData = [
      {
        item: "未消费用户",
        count: this.userPayment.notPaidUserCount,
      },
      {
        item: "已消费用户",
        count: this.userPayment.paidUserCount,
      },
    ];
    const dv = new DataSet.View().source(sourceData);
    dv.transform({
      type: "percent",
      field: "count",
      dimension: "item",
      as: "percent",
    });
    return dv.rows;
  }
}
